import { jsx as _jsx } from "react/jsx-runtime";
import ProductFeaturesMap from 'self-service-api/constants/ProductFeaturesMap';
import styled from 'styled-components';
import { getLangEligibleFeatureIds } from 'self-service-api/api/getLangEligibleFeatureIds';
import { GYPSUM, OLAF } from 'HubStyleTokens/colors';
import FeaturesProvider from 'ui-addon-upgrades/_core/features/FeaturesProvider';
import FeaturesSuiteTable from 'ui-addon-upgrades/_core/features/FeaturesSuiteTable';
import { useAppSelector } from '../../../../reducers';
import { productSelector } from '../../../../selectors/ProductsSelectors';
import { getAllFeaturesByAllProductLinesSelector } from '../../../../selectors/FeatureSelectors';
import { isUngatedForFeatureStore } from '../../../../selectors/GatingSelectors';
import MobileSuiteCatalogTableCell from './MobileSuiteCatalogTableCell';
const TableRow = styled.tr.withConfig({
  displayName: "MobileSuiteCatalogFeaturesTable__TableRow",
  componentId: "dzq4dt-0"
})([":nth-child(even){background-color:", ";:hover{background-color:", ";}& > th{background-color:", ";}}:nth-child(odd){background-color:", ";:hover{background-color:", ";}& > th{background-color:", ";}}"], OLAF, OLAF, OLAF, GYPSUM, GYPSUM, GYPSUM);
const Table = styled.table.withConfig({
  displayName: "MobileSuiteCatalogFeaturesTable__Table",
  componentId: "dzq4dt-1"
})(["border-spacing:0;width:100%;margin-bottom:0;"]);

const MobileSuiteCatalogFeaturesTable = ({
  productLine,
  productLevel
}) => {
  const features = Object.keys(ProductFeaturesMap[productLine][productLevel]);
  const filteredFeatures = getLangEligibleFeatureIds(features);
  const isUngatedForFS = useAppSelector(isUngatedForFeatureStore);
  const apiName = useAppSelector(state => {
    const product = productSelector(state, {
      productLine,
      productLevel
    });
    return product && product.apiName;
  });
  const passedInFeatures = useAppSelector(getAllFeaturesByAllProductLinesSelector);
  const apiNames = apiName ? [apiName] : [];

  if (isUngatedForFS) {
    return /*#__PURE__*/_jsx(FeaturesProvider, {
      highlightedProducts: apiNames,
      productLine: productLine,
      passedInFeatures: passedInFeatures,
      children: /*#__PURE__*/_jsx(FeaturesSuiteTable, {
        productLine: productLine
      })
    });
  }

  return /*#__PURE__*/_jsx(Table, {
    children: /*#__PURE__*/_jsx("tbody", {
      children: filteredFeatures.map(feature => /*#__PURE__*/_jsx(TableRow, {
        children: /*#__PURE__*/_jsx(MobileSuiteCatalogTableCell, {
          feature: feature,
          productLine: productLine,
          productLevel: productLevel
        }, feature)
      }, feature))
    })
  });
};

export default MobileSuiteCatalogFeaturesTable;